import {Component, OnInit} from '@angular/core';
import {BlockListService} from "../../services/block-list.service";
import {Router} from "@angular/router";
import {catchError, throwError} from "rxjs";
import Swal from "sweetalert2";
import {FormsModule} from "@angular/forms";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-block-list',
  standalone: true,
  imports: [
    FormsModule,
    NgForOf
  ],
  templateUrl: './block-list.component.html',
  styleUrl: './block-list.component.css'
})
export class BlockListComponent implements OnInit{

  searchTerm: string = '';
  blockList: any[] = [];

  constructor(
    private blockListService: BlockListService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getBlockList();
  }

  get filteredBockList() {
    return this.blockList.filter(block =>
      block.nome.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      block.telefono.includes(this.searchTerm)
    );
  }

  getBlockList() {
    this.blockListService.getBlockList()
      .pipe(
        catchError(error => {
          console.error("Errore nel recupero della lista ", error);
          return throwError(error);
        })
      )
      .subscribe((response) => {
        // Trasforma usersList sulla base del risultato
        this.blockList = response.blockList;
        console.log('Lista blocchi recuperata:', this.blockList);
      });
  }

  aggiungiBlocco() {

    Swal.fire({
      title: `Nuovo blocco`,
      html: `
      <input id="nome" placeholder="nome" class="input mt-2"  type="text">
      <input id="telefono" placeholder="telefono" class="input mt-2"  type="text">
    `,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#ec008d",
      cancelButtonColor: "#6B7579",
      confirmButtonText: "Conferma",
      cancelButtonText: "Annulla",
      preConfirm: () => {
        const nome = (document.getElementById('nome') as HTMLInputElement).value;
        const telefono = (document.getElementById('telefono') as HTMLInputElement).value;
        return { nome: nome, telefono: telefono };
      }
    }).then((result) => {
      if (result.isConfirmed) {

        this.blockListService.addBlocklist(result.value.nome,result.value.telefono)
          .pipe(
            catchError(error => {
              console.error("Errore nell'aggiunta del blocco", error);

              Swal.fire({
                icon: 'error',
                title: 'Ops...',
                text: "Errore nell'aggiunta del blocco",
                confirmButtonColor: '#050A30'
              });

              return throwError(error);
            })
          )
          .subscribe((response) => {

            this.getBlockList();

            Swal.fire({
              icon: 'success',
              title: 'Blocco aggiunto',
              timer: 1000
            });

            console.log('Blocco aggiunto con successo:', response);
          });
      }
    });
  }

  deleteBlock(block: any): void {
    Swal.fire({
      title: `Sei sicuro di voler eliminare il blocco ${block.nome}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#ec008d",
      cancelButtonColor: "#6B7579",
      confirmButtonText: "Elimina comunque",
      cancelButtonText: "Non eliminare",
    }).then((result) => {
      if (result.isConfirmed) {
        this.blockListService.deleteBlocklist(block._id)
          .pipe(
            catchError(error => {
              console.error("Errore nell'eliminazioe del blocco", error);

              Swal.fire({
                icon: 'error',
                title: 'Ops...',
                text: "Errore nell'eliminazioe",
                confirmButtonColor: '#050A30'
              });

              return throwError(error);
            })
          )
          .subscribe((response) => {

            //Aggiorno il render degli account
            this.getBlockList();

            Swal.fire({
              icon: 'success',
              title: 'Blocco eliminato',
              timer: 1000
            });

            console.log('Blocco eliminato con successo:', response);
          });
      }
    });
  }

}
